"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InsertVideoConferenceButtonWithConfig;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIUnstyledButton = _interopRequireDefault(require("UIComponents/button/UIUnstyledButton"));

var _VideoConferencePluginStore = _interopRequireDefault(require("crm_data/meeting/stores/VideoConferencePluginStore"));

var _VideoConferenceStore = _interopRequireDefault(require("crm_data/extensions/videoConference/VideoConferenceStore"));

var _ContactsStore = _interopRequireDefault(require("crm_data/contacts/ContactsStore"));

var _ConfirmUpdateConferenceModal = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/plugins/videoConference/ConfirmUpdateConferenceModal"));

var _insertAtomicBlockWithData = _interopRequireDefault(require("draft-plugins/utils/insertAtomicBlockWithData"));

var _changeBlockData = _interopRequireDefault(require("draft-plugins/utils/changeBlockData"));

var _immutable = require("immutable");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _generalStore = require("general-store");

var _VideoConferenceActions = require("crm_data/extensions/videoConference/VideoConferenceActions");

var _I18n = require("I18n");

var _VideoConferencePluginConstants = require("customer-data-communicator/lib/draftjs/plugins/videoConference/VideoConferencePluginConstants");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

function InsertVideoConferenceButtonWithConfig(wrapperProps) {
  var InsertVideoConferenceButton =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(InsertVideoConferenceButton, _PureComponent);

    function InsertVideoConferenceButton() {
      var _this;

      (0, _classCallCheck2.default)(this, InsertVideoConferenceButton);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InsertVideoConferenceButton).call(this));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.partial = (0, _ComponentMethods.makePartial)();
      _this.state = {
        open: false
      };
      return _this;
    }

    (0, _createClass2.default)(InsertVideoConferenceButton, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(lastProps) {
        if (lastProps.meetingInteraction && this.props.meetingInteraction && (lastProps.meetingInteraction.metadata.get('startTime') !== this.props.meetingInteraction.metadata.get('startTime') || lastProps.meetingInteraction.metadata.get('endTime') !== this.props.meetingInteraction.metadata.get('endTime'))) {
          this.handleUpdateConferenceTime();
        }
      }
    }, {
      key: "getVideoConferenceBlocks",
      value: function getVideoConferenceBlocks() {
        return this.props.editorState.getCurrentContent().getBlockMap().filter(function (block) {
          return block.data.get('atomicType') === _VideoConferencePluginConstants.DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE;
        });
      }
    }, {
      key: "getBlockMetadata",
      value: function getBlockMetadata(appId) {
        var _this$props = this.props,
            meetingInteraction = _this$props.meetingInteraction,
            associatedContactRecords = _this$props.associatedContactRecords;

        var defaultTime = _I18n.moment.userTz().valueOf();

        var startTime = meetingInteraction.metadata.get('startTime') || defaultTime;
        var endTime = meetingInteraction.metadata.get('endTime') || defaultTime;
        var topic = meetingInteraction.metadata.get('title') || '';
        var invitees = associatedContactRecords.map(function (contact) {
          return {
            email: contact.getIn(['properties', 'email', 'value']),
            firstName: contact.getIn(['properties', 'firstname', 'value']),
            lastName: contact.getIn(['properties', 'lastname', 'value'])
          };
        });
        return (0, _VideoConferenceActions.getLink)({
          appId: appId,
          startTime: startTime,
          endTime: endTime,
          topic: topic,
          source: 'MANUAL',
          invitees: invitees
        }).then(function (data) {
          return (0, _immutable.Map)({
            atomicType: _VideoConferencePluginConstants.DRAFT_ATOMIC_TYPE_VIDEO_CONFERENCE,
            text: data.get('conferenceDetails', '').replace(/(?:\r\n|\r|\n)/g, '<br />'),
            url: data.get('conferenceId'),
            conferenceId: data.get('conferenceId'),
            appId: appId
          });
        }).catch(function () {
          (0, _Alerts.addDanger)('customerDataCommunicator.videoConferencePlugin.generateLinkFailed');
        });
      }
    }, {
      key: "handleUpdateConferenceBlock",
      value: function handleUpdateConferenceBlock(blockToUpdate) {
        var _this2 = this;

        var appId = blockToUpdate.getIn(['data', 'appId']);

        if (!appId) {
          return;
        }

        this.getBlockMetadata(appId).then(function (blockMetadata) {
          _this2.props.onChange((0, _changeBlockData.default)({
            editorState: _this2.props.editorState,
            block: blockToUpdate,
            updatedBlockData: blockMetadata
          }));
        });
      }
    }, {
      key: "handleUpdateConferenceTime",
      value: function handleUpdateConferenceTime() {
        var _this3 = this;

        var conferenceBlocks = this.getVideoConferenceBlocks();

        if (conferenceBlocks && conferenceBlocks.size) {
          var appId = conferenceBlocks.first().getIn(['data', 'appId']);
          var app = this.props.videos.find(function (integration) {
            return integration.getIn(['application', 'id']) === appId;
          });
          (0, _ConfirmUpdateConferenceModal.default)({
            appName: app.getIn(['application', 'name'])
          }).then(function () {
            return conferenceBlocks.forEach(_this3.handleUpdateConferenceBlock);
          });
        }
      }
    }, {
      key: "handleOpen",
      value: function handleOpen() {
        if (wrapperProps && wrapperProps.onOpenPopover) {
          wrapperProps.onOpenPopover();
        }

        this.setState({
          open: true
        });
      }
    }, {
      key: "handleClose",
      value: function handleClose() {
        this.setState({
          open: false
        });
      }
    }, {
      key: "handleOpenChange",
      value: function handleOpenChange(evt) {
        this.setState({
          open: evt.target.value
        });
      }
    }, {
      key: "handleAddConferenceLink",
      value: function handleAddConferenceLink(appId) {
        var _this4 = this;

        this.getBlockMetadata(appId).then(function (videoBlockMetadata) {
          _this4.props.onChange((0, _insertAtomicBlockWithData.default)(_this4.props.editorState, videoBlockMetadata));
        });
      }
    }, {
      key: "handleClickDropdownButton",
      value: function handleClickDropdownButton(appId) {
        this.handleAddConferenceLink(appId);
        this.handleClose();
      }
    }, {
      key: "renderAddVideoConfLinkButton",
      value: function renderAddVideoConfLinkButton(videoApp) {
        var id = videoApp.getIn(['application', 'id']);
        return _react.default.createElement(_UIButton.default, {
          use: "link",
          key: id,
          onClick: this.partial(this.handleClickDropdownButton, id)
        }, videoApp.getIn(['application', 'name']));
      }
    }, {
      key: "renderConnectIntegrationButton",
      value: function renderConnectIntegrationButton(videoApp) {
        var id = videoApp.getIn(['application', 'id']);
        return _react.default.createElement("div", {
          className: "disabled-video-conference-option",
          key: id
        }, _react.default.createElement("div", null, videoApp.getIn(['application', 'name'])), _react.default.createElement(_Small.default, null, _react.default.createElement("div", {
          className: "video-conference-link-to-acct",
          dangerouslySetInnerHTML: {
            __html: videoApp.get('message')
          }
        })));
      }
    }, {
      key: "renderDropdownButtons",
      value: function renderDropdownButtons() {
        var _this5 = this;

        return this.props.videos.sortBy(function (videoApp) {
          return videoApp.get('available');
        }).map(function (videoApp) {
          var isAvailable = videoApp.get('available');

          if (isAvailable) {
            return _this5.renderAddVideoConfLinkButton(videoApp);
          }

          return _this5.renderConnectIntegrationButton(videoApp);
        }).toList();
      }
    }, {
      key: "render",
      value: function render() {
        if (!this.props.videos) {
          return null;
        }

        var tooltip = _react.default.createElement(_FormattedMessage.default, {
          message: "customerDataCommunicator.videoConferencePlugin." + (!this.props.videos.size ? 'disabled' : 'tooltip')
        });

        return _react.default.createElement(_UIPopover.default, {
          open: this.state.open,
          closeOnOutsideClick: true,
          onOpenChange: this.handleOpenChange,
          content: _react.default.createElement(_UIList.default, {
            inline: false,
            className: "private-dropdown--list video-conference-list"
          }, this.props.videos.size ? this.renderDropdownButtons() : null)
        }, _react.default.createElement(_UITooltip.default, {
          title: tooltip,
          placement: "bottom"
        }, _react.default.createElement(_UIUnstyledButton.default, {
          onClick: this.handleOpen,
          disabled: !this.props.videos.size
        }, _react.default.createElement(_UIIcon.default, {
          name: "insertVideo"
        }))));
      }
    }]);
    return InsertVideoConferenceButton;
  }(_PureComponent2.default);

  return (0, _generalStore.connect)({
    videos: _VideoConferenceStore.default,
    meetingInteraction: {
      stores: [_VideoConferencePluginStore.default],
      deref: function deref() {
        if (wrapperProps.meetingId) {
          var meetingInteraction = _VideoConferencePluginStore.default.get("" + wrapperProps.meetingId);

          if (meetingInteraction) {
            return meetingInteraction;
          }
        }

        return _VideoConferencePluginStore.default.get('communicatorInteraction');
      }
    },
    associatedContactRecords: {
      stores: [_VideoConferencePluginStore.default, _ContactsStore.default],
      deref: function deref() {
        var contactIds = _VideoConferencePluginStore.default.get('associatedContactIds');

        return _ContactsStore.default.get(contactIds);
      }
    }
  }, _dispatcher.default)(InsertVideoConferenceButton);
}

module.exports = exports.default;